import Asset from "./Asset";
import * as PIXI from "pixi.js";

export default class TextAsset extends Asset
{
    constructor(strText)
    {
        super();

        this.build(strText);
    }

    build (strText)
    {
        const style = new PIXI.TextStyle({
                                             fill: "#7588c2",
                                             padding: 2
                                         });

        this.sprite = new PIXI.Text(strText, style);

        this.addChild(this.sprite);

        this.buildContainer();

        this.x = 500;
        this.y = 500;

    }
}
